"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const puzzledIcon = require('@assets/icon/puzzled.svg');
const CouldNotLoadDataView = ({ message, }) => react_1.default.createElement("div", { className: "could-not-load-data-container" },
    react_1.default.createElement("img", { src: puzzledIcon, className: "icon", alt: "N\u011Bco se pokazilo, zkuste to pros\u00EDm pozd\u011Bji.", width: "50", height: "50" }),
    message,
    react_1.default.createElement("br", null),
    "Skupina vysoce tr\u00E9novan\u00FDch aj\u0165\u00E1k\u016F u\u017E pracuje na oprav\u011B.",
    react_1.default.createElement("br", null),
    react_1.default.createElement("span", { className: "try-it-later" }, "Zkuste to pros\u00EDm pozd\u011Bji."));
exports.default = CouldNotLoadDataView;
